import React from 'react';
import { browserHistory } from 'react-router';
import _ from 'lodash';

import {
  ORDER_TYPE_TAKEAWAY,
  ORDER_TYPE_DELIVERY,
} from '@arreeba/ristoranti-frontend-lib/lib/constants';

import { connect } from '../../util';
import Url from '../../lib/url';
import { userRequired } from '../user/';
import { orderLocationAddressSelector } from '../../selectors/orderSelectors';
import GoogleMap from '../../components/google-map';
import OrderRecap from '../../components/order-recap';
import ButtonsContainer from '../../components/buttonsContainer';
import BackButton from '../../components/back-button';
import OrderTakeAwayForm from '../../components/order-takeaway-form';
import OrderDeliveryForm from '../../components/order-delivery-form';

const formBaseConfig = [
  {
    label: 'Telefono',
    name: 'phoneNumber',
    format: 'phoneNumber',
    placeholder: '1234567',
    initialValue: '',
    isRequired: true,
  },
  {
    label: 'E-mail',
    name: 'email',
    format: 'email',
    placeholder: 'nome@provider.ext',
    initialValue: '',
    isRequired: true,
  },
  {
    label: 'Note',
    name: 'extraInfo',
    format: 'text',
    placeholder: 'Richieste aggiuntive',
    initialValue: '',
    isRequired: false,
  },
];

class OrderCheckout extends React.Component {
  constructor(props) {
    super(props);
    this.goToPayment = this.goToPayment.bind(this);
  }

  goToPayment(formData) {
    const data = _.omit(formData, ['extraInfo']);
    if (formData.extraInfo.length > 0) {
      data.extraInfo = formData.extraInfo;
    }
    this.props.actions.order.setDeliveryData({
      ...data,
      ...this.props.order.deliveryAddress,
    });
    browserHistory.push(Url.orderPayment(this.props.url));
  }

  render() {
    const user = this.props.user.currentUser || {};
    const orderLocation = this.props.orderLocation;
    const orderType = this.props.url.orderType;
    const orderDate = this.props.url.orderDate;
    return (
      <main>
        <header>
          <h4>Ci servono alcune informazioni aggiuntive per concludere l'ordine</h4>
          <OrderRecap
            date={orderDate}
            location={orderLocation.address}
          />
          <GoogleMap
            markers={[orderLocation.coords]}
            center={orderLocation.coords}
          />
        </header>
        {orderType === ORDER_TYPE_TAKEAWAY &&
          <OrderTakeAwayForm
            baseConfig={formBaseConfig}
            initialData={user}
            onSave={this.goToPayment}
          />
        }
        {orderType === ORDER_TYPE_DELIVERY &&
          <OrderDeliveryForm
            baseConfig={formBaseConfig}
            initialData={user}
            onSave={this.goToPayment}
          />
        }
        <ButtonsContainer>
          <BackButton />
        </ButtonsContainer>
      </main>
    );
  }
}

const mapStateToProps = (state, props) => ({
  url: props.url,
  user: state.user,
  order: state.order,
  orderLocation: orderLocationAddressSelector(state, props),
});

export default userRequired(connect(OrderCheckout, { mapStateToProps }));



// WEBPACK FOOTER //
// ./src/containers/order/order-checkout.js